import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { CountryFlag } from 'src/components/country-flag';
import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';

interface ICountryBadge {
  countryCode: string;
}

export const CountryBadge: React.FC<ICountryBadge> = props => {
  const { countryCode } = props;
  const { t } = useAppContext();

  return (
    <CountryFlag
      show
      countryCode={countryCode}
      title={t(
        'common',
        `market.${countryCode}` as keyof ParamsAndReturnTypes['common']
      )}
      tooltipPlacement="top"
    />
  );
};
